module.exports = __webpack_public_path__ + "img/fly.21c2cf6a.png";